import { useRef, useState } from 'react'
import api from '../../../services/api'
import { Form, Modal } from 'antd'
import { displayMessage } from '../../../helpers/messages'
import { SL_Input } from '../../../components/input/Input'

const STATUS_SUCCESS = 200

export function ModalCreateStrength({ isOpen, onClose, reloadStrengths }) {
    const formRef = useRef()

    const [loading, setLoading] = useState(false)

    const onSubmit = async strength => {
        setLoading(true)
        try {
            const response = await api.strengths.create(strength)

            if (response.status === STATUS_SUCCESS) {
                onClose(false)
                await reloadStrengths()
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            title={displayMessage('STRENGTH_CREATION')}
            centered
            open={isOpen}
            onOk={() => formRef.current.submit()}
            confirmLoading={loading}
            onCancel={() => onClose(false)}
            okText={displayMessage('FINISH')}
            maskClosable={false}
        >
            <Form onFinish={onSubmit} className="max-w-[700px] w-full" layout="vertical" requiredMark={false} ref={formRef}>
                <div className="flex flex-col gap-1">
                    <div className="">{displayMessage('TITLE')}</div>

                    <Form.Item name="title" rules={[{ required: true, message: displayMessage('DISPLAY_TITLE') }]} className="mb-4">
                        <SL_Input placeholder={displayMessage('TITLE')} className={'w-full'} />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}
